module.exports = __webpack_public_path__ + "img/image-roll-01.c764755c.svg";